// Tenancy
export const auth = "api/User/authenticate";
export const verifyotp = "api/User/verifyotp";
export const resendotp = "api/User/resendotp";
export const forgotPassword = "api/User/ForgotPassword";
export const linkExpirationCheck = "api/User/LinkExpirationCheck";
export const changePassoword = "api/User/ChangePasword";
export const getUserModules = "api/AppModule/GetUserModules";
export const getModuleActions = "api/AppModule/GetModuleActions";
export const getUserConsignors = "api/Consignor/GetUserConsignors";
export const getSubModules = "api/AppModule/GetUserSubModules";
export const getRolesList = "api/RoleManagement/GetRolesList";
export const getRoleRightMapping = "api/RoleManagement/GetRole";
export const createRole = "api/RoleManagement/CreateRole";
export const updatRole = "api/RoleManagement/UpdateRole";
export const deleteRole = "api/RoleManagement/DeleteRole";



// App Registration  
export const createApp = "api/AppModule/CreateApp";
export const updateApp = "api/AppModule/UpdateApp";
export const deleteApp = "api/AppModule/DeleteApp";
export const getAppList = "api/AppModule/GetAppList";
export const getAppDetail = "api/AppModule/GetAppDetail";
export const taskqueue = "api/AppModule/TaskQueue";
//export const getDropDownCustomerList = "api/Customer/GetDropDownCustomerList";


export const getMobileRoleRightMapping =
  "api/MobileRoleManagement/GetMobileRole";
export const createMobileRole = "api/MobileRoleManagement/CreateMobileRole";
export const getMobileRolesList = "api/MobileRoleManagement/GetMobileRolesList";
export const updatMobileRole = "api/MobileRoleManagement/UpdateMobileRole";
export const deleteMobileRole = "api/MobileRoleManagement/DeleteMobileRole";
// Master MicroService

export const getFacilityList = "api/Facility/GetFacilityList";
export const getCreateFacility = "api/Facility/CreateFacility";
export const getUpdateFacility = "api/Facility/UpdateFacility";
export const deleteFacility = "api/Facility/DeleteFacility";
export const getDropDownFacilityList = "api/Facility/GetDropDownFacilityList";
export const getUserFacilities = "api/Facility/GetUserFacilities";
export const getFacilities = "api/Facility/GetFacilities";
export const exportFacilityList = "api/Facility/ExportFacilityList";
export const getFacilityByCode = "api/Facility/GetFacilityByCode";
export const getExcludedFacilityList = "api/Facility/GetExcludedFacilityList";
export const toggleActivationFacility = "api/Facility/ToggleActivationFacility";

export const createPrinciple = "api/Principal/CreatePrincipal";
export const updatePrinciple = "api/Principal/UpdatePrincipal";
export const deletePrinciple = "api/Principal/DeletePrincipal";
export const getPrincipleList = "api/Principal/GetPrincipalList";
export const getPrincipleById = "api/Principal/GetPrincipalByCode";
export const getDropDownPrincipleList =
  "api/Principal/GetDropDownPrincipalList";
export const getUserPrincipals = "api/Principal/GetUserPrincipals";

export const getDockList = "api/Dock/GetDockList";
export const createDock = "api/Dock/CreateDock";
export const updateDock = "api/Dock/UpdateDock";
export const deleteDock = "api/Dock/DeleteDock";
export const geteDocks = "api/Dock/GetDocks";

export const getSupplierList = "api/Supplier/GetSupplierList";
export const createSupplier = "api/Supplier/CreateSupplier";
export const updateSupplier = "api/Supplier/UpdateSupplier";
export const deleteSupplier = "api/Supplier/DeleteSupplier";
export const getDropDownSupplierList = "api/Supplier/GetDropDownSupplierList";

export const getUOMGroupList = "api/UOMGroup/GetUOMGroupList";
export const createUOMGroup = "api/UOMGroup/CreateUOMGroup";
export const updateUOMGroup = "api/UOMGroup/UpdateUOMGroup";
export const deleteUOMGroup = "api/UOMGroup/DeleteUOMGroup";
export const getUOMGroupRelation = "api/UOMGroup/GetUOMGroupRelation";
export const getUOMGroupHierarchy = "api/UOMGroup/GetUOMGroupHierarchy";
export const getUOMGroups = "api/UOMGroup/GetUOMGroups";
export const getUOMGroupRelationWithBaseUOM =
  "api/UOMGroup/GetUOMGroupRelationWithBaseUOM";

export const getUOMList = "api/UOM/GetUOMList";
export const createUOM = "api/UOM/CreateUOM";
export const updateUOM = "api/UOM/UpdateUOM";
export const deleteUOM = "api/UOM/DeleteUOM";
export const getBaseUOM = "api/UOM/GetUOMs";
export const getSecondaryUOM = "api/UOM/GetSecondaryUOMHeirarchy";

export const getFacilityUOMUnloadingTime =
  "api/UOMUnloadingTime/GetFacilityUOMUnloadingTime";
export const createUOMUnloadingTime =
  "api/UOMUnloadingTime/CreateUOMUnloadingTime";
export const updateUOMUnloadingTime =
  "api/UOMUnloadingTime/UpdateUOMUnloadingTime";
export const getUOMUnloadingTimeList =
  "api/UOMUnloadingTime/GetUOMUnloadingTimeList";

export const createCustomer = "api/Customer/CreateCustomer";
export const updateCustomer = "api/Customer/UpdateCustomer";
export const deleteCustomer = "api/Customer/DeleteCustomer";
export const getCustomerList = "api/Customer/GetCustomerList";
export const getDropDownCustomerList = "api/Customer/GetDropDownCustomerList";

export const createUser = "api/User/CreateUser";
export const updateUser = "api/User/UpdateUser";
export const deleteUser = "api/User/DeleteUser";
export const getUserList = "api/User/GetUsersList";
export const getUserRoles = "api/User/GetRoles";
export const getUserListByUid = "api/User/GetUsersListByUid";

// App Notification 

export const getAppNotificationList = "api/AppNotification/GetAppNotificationList";
export const updateAppNotification = "api/AppNotification/UpdateAppNotification";
export const getAppNotification = "api/AppNotification/getAppNotification";

export const deleteMobileUser = "api/MobileUser/DeleteMobileUser";
export const getMobileUserList = "api/MobileUser/GetMobileUsersList";
export const getMobileUserRoles = "api/MobileUser/GetMobileRoles";
export const createMobileUser = "api/MobileUser/CreateMobileUser";
export const getMobileUserListByUid = "api/MobileUser/GetMobileUsersListByUid";
export const updateMobileUser = "api/MobileUser/UpdateMobileUser";
export const toggleActivationMobileUser =
  "api/MobileUser/ToggleActivationMobileUser";

export const getDimensionGroupList = "api/DimensionGroup/GetDimensionGroupList";
export const createDimensionGroup = "api/DimensionGroup/CreateDimensionGroup";
export const updateDimensionGroup = "api/DimensionGroup/UpdateDimensionGroup";
export const deleteDimensionGroup = "api/DimensionGroup/DeleteDimensionGroup";
export const getDimensionGroups = "api/DimensionGroup/GetDimensionGroups";

export const getLocationProfileList =
  "api/LocationProfile/GetLocationProfileList";
export const createLocationProfile =
  "api/LocationProfile/CreateLocationProfile";
export const updateLocationProfile =
  "api/LocationProfile/UpdateLocationProfile";
export const deleteLocationProfile =
  "api/LocationProfile/DeleteLocationProfile";
export const getLocationProfileUOM =
  "api/LocationProfile/GetLocationProfileUOM";
export const getLocationProfiles = "api/LocationProfile/GetLocationProfiles";
export const getLocationProfilesBasedOnLocationHeaders =
  "api/LocationProfile/GetLocationProfilesBasedOnLocationHeaders";

export const getLocationFormatList = "api/LocationFormat/GetLocationFormatList";
export const createLocationFormat = "api/LocationFormat/CreateLocationFormat";
export const updateLocationFormat = "api/LocationFormat/UpdateLocationFormat";
export const deleteLocationFormat = "api/LocationFormat/DeleteLocationFormat";
export const getLocationFormats = "api/LocationFormat/GetLocationFormats";
export const getLocationFormatSegments =
  "api/LocationFormat/GetLocationFormatSegments";

export const getSKUMainGroupList = "api/SKUMainGroup/GetSKUMainGroupList";
export const createSKUMainGroup = "api/SKUMainGroup/CreateSKUMainGroup";
export const updateSKUMainGroup = "api/SKUMainGroup/UpdateSKUMainGroup";
export const deleteSKUMainGroup = "api/SKUMainGroup/DeleteSKUMainGroup";
export const dropdownSKUMainGroup =
  "api/SKUMainGroup/GetDropDownSkuMainGroupList";

export const getSKUSubGroupList = "api/SKUSubGroup/GetSKUSubGroupList";
export const createSKUSubGroup = "api/SKUSubGroup/CreateSKUSubGroup";
export const updateSKUSubGroup = "api/SKUSubGroup/UpdateSKUSubGroup";
export const deleteSKUSubGroup = "api/SKUSubGroup/DeleteSKUSubGroup";
export const getSKUSubGroupByCode = "api/SKUSubGroup/GetSKUSubGroupByCode";
export const getSKUSubGroups = "api/SKUSubGroup/GetSKUSubGroups";
export const getSKUSubGroupAttribute =
  "api/SKUSubGroup/GetSKUSubGroupAttribute";
export const toggleActivationSkuSubGroup =
  "api/SKUSubGroup/ToggleActivationSkuSubGroup";

export const getLocationZoneList = "api/LocationZone/GetLocationZoneList";
export const createLocationZone = "api/LocationZone/CreateLocationZone";
export const updateLocationZone = "api/LocationZone/UpdateLocationZone";
export const deleteLocationZone = "api/LocationZone/DeleteLocationZone";
export const getLocationZones = "api/LocationZone/GetLocationZones";

export const generateLocation = "api/Location/GenerateLocation";
export const createLocation = "api/Location/CreateLocation";
export const getExistingSegment = "api/Location/GetExistingSegment";
export const getLocationList = "api/Location/GetLocationList";
export const updateLocation = "api/Location/UpdateLocation";
export const deleteLocation = "api/Location/DeleteLocation";
export const getLocations = "api/Location/GetLocations";
export const getAllLocationsDataWithCodes =
  "api/Location/GetAllLocationsDataWithCodes";
export const getLocationListBasedOnLocationProfile =
  "api/Location/GetLocationListBasedOnLocationProfile";

export const createLocationPrincipal =
  "api/LocationPrincipal/CreateLocationPrincipal";

export const getAppointmentList = "api/Appointment/GetAppointmentList";
export const createAppointment = "api/Appointment/CreateAppointment";
export const updateAppointment = "api/Appointment/UpdateAppointment";
export const deleteAppointment = "api/Appointment/DeleteAppointment";
export const getAppointmentByCode = "api/Appointment/GetAppointmentByCode";
export const putAppointmentStatusByCode =
  "api/Appointment/PutAppointmentStatusByCode";
export const getAppointmentStatus = "api/Appointment/GetAppointmentStatus";
export const getUOMQuantityList = "api/Appointment/GetUOMQuantityList";
export const getBookedAppointmentDates =
  "api/Appointment/GetBookedAppointmentDates";
export const getPendingAppointments = "api/Appointment/GetPendingAppointments";

export const getGateEntryList = "api/GateEntry/GetGateEntryList";
export const putGateEntryStatusByCode =
  "api/GateEntry/PutGateEntryStatusByCode";
export const deleteGateEntry = "api/GateEntry/DeleteGateEntry";

export const getCountriesList = "api/Helper/GetCountriesList";

export const createHolidays = "api/Holidays/CreateHolidays";
export const getHolidaysByCode = "api/Holidays/GetHolidaysByCode";

export const createHolidayCalendar = "api/HolidayCalendar/CreateHolidayCalendar";
export const getHolidayCalendar = "api/HolidayCalendar/GetHolidayCalendar";
export const getNationalHolidayCalendar = "api/HolidayCalendar/GetNationalHolidayCalendar";

export const getComments = "api/CommentManager/GetCommentManagerList";
export const createComment = "api/CommentManager/CreateCommentManager";

//SKU
export const createSKU = "api/SKU/CreateSKU";
export const updateSKU = "api/SKU/UpdateSKU";
export const deleteSKU = "api/SKU/DeleteSKU";
export const getSKUAttribute = "api/SKU/GetSKUAttribute";
export const getSKUs = "api/SKU/GetSKUs";
export const getSKUParents = "api/SKU/GetSKUParents";
export const getSKUList = "api/SKU/GetSKUList";
export const viewSKU = "api/SKU/viewSKU";

export const createInwardType = "api/InwardType/CreateInwardType";
export const updateInwardType = "api/InwardType/UpdateInwardType";
export const deleteInwardType = "api/InwardType/DeleteInwardType";
export const getInwardTypeList = "api/InwardType/GetInwardTypeList";
export const getInwardTypes = "api/InwardType/GetInwardTypes";
export const toggleActivationInwardType =
  "api/InwardType/ToggleActivationInwardType";

export const createPallet = "api/Pallet/CreatePallet";
export const updatePallet = "api/Pallet/UpdatePallet";
export const deletePallet = "api/Pallet/DeletePallet";
export const getPalletList = "api/Pallet/GetPalletList";
export const getPallets = "api/Pallet/GetPallets";

export const getCountrys = "api/Country/GetCountrys";
export const getStates = "api/State/GetStates";
export const getCitys = "api/City/GetCitys";

export const createConsignor = "api/Consignor/CreateConsignorVersion1";
export const createConsignorRateChart = "api/Consignor/CreateConsignorRateChart";
export const updateConsignor = "api/Consignor/UpdateConsignorVersion1";
export const deleteConsignor = "api/Consignor/DeleteConsignor";
export const getConsignorList = "api/Consignor/GetConsignorList";
export const viewConsignor = "api/Consignor/viewConsignorVersion1";
export const viewConsignorRateChartDetail = "api/Consignor/ViewConsignorRateChartDetail";
export const getConsignors = "api/Consignor/GetConsignors";
export const getConsignorWithDefaultAddress = "api/Consignor/GetConsignorWithDefaultAddress";
export const getConsignorWithDefaultAddressTypeWise = "api/ConsignorV1/GetConsignorWithDefaultAddress";
export const getConsignorV1List = "api/Consignorv1/GetConsignorList";

export const createConsignorv1 = "api/ConsignorV1/CreateConsignor";
export const updateConsignorv1 = "api/ConsignorV1/UpdateConsignor";
export const updateConsignorMainSetupv1 = "api/ConsignorV1/UpdateConsignorMainSetup";
export const deleteConsignorv1 = "api/ConsignorV1/DeleteConsignor";
export const viewConsignorv1 = "api/Consignorv1/viewConsignor";
export const viewConsignorMainSetupv1 = "api/Consignorv1/viewConsignorMainSetup";
export const createConsignorRateChartv1 = "api/Consignorv1/CreateConsignorRateChartv1";
export const viewConsignorRateChartDetailv1 = "api/Consignorv1/ViewConsignorRateChartDetail";
export const getConsignorWithDefaultAddressv1 = "api/Consignorv1/GetConsignorWithDefaultAddress";
export const viewConsignorRateChartPinCodeTATv1 = "api/Consignorv1/ViewConsignorRateChartPinCodeTAT";
export const updateConsignorRateChartPinCodeTATsv1 = "api/Consignorv1/UpdateConsignorRateChartPinCodeTATs";
export const createConsignorRateChartB2C = "api/Consignor/CreateConsignorRateChartB2C";
export const createConsignorRateChartSettingWiseB2C = "api/Consignor/CreateConsignorRateChartSettingWiseB2C";
export const exportConsignorList = "api/Consignor/ExportConsignorList";

export const createConsignorRule = "api/ConsignorRule/CreateConsignorRuleVersion1";
export const updateConsignorRule = "api/ConsignorRule/UpdateConsignorRuleVersion1";
export const deleteConsignorRule = "api/ConsignorRule/DeleteConsignorRule";
export const getConsignorRuleList = "api/ConsignorRule/GetConsignorRuleList";
export const viewConsignorRule = "api/ConsignorRule/ViewConsignorRuleVersion1";
export const getConsignorRules = "api/ConsignorRule/GetConsignorRules";
export const deleteConsignorRuleB2C = "api/ConsignorRule/DeleteConsignorRuleB2C";


export const createConsignorSetup =
  "api/ConsignorSetup/CreateConsignorSetupVersion1";
export const updateConsignorSetup =
  "api/ConsignorSetup/UpdateConsignorSetupVersion1";
export const deleteConsignorSetup = "api/ConsignorSetup/DeleteConsignorSetup";
export const getConsignorSetupList = "api/ConsignorSetup/GetConsignorSetupList";
export const viewConsignorSetup = "api/ConsignorSetup/ViewConsignorSetupVersion1";
export const viewConsignorSetup2 = "api/ConsignorSetup/ViewConsignorSetupVersion2";
export const getConsignorSetups = "api/ConsignorSetup/GetConsignorSetups";
export const viewConsignorSetupTypeWise = "api/ConsignorSetup/ViewConsignorSetupTypeWise";
export const ViewConsignorZohoSetupTypeWise = "api/ConsignorZohoSetup/ViewConsignorZohoSetupTypeWise";


export const createCarrier = "api/Carrier/CreateCarrierVersion1";
export const updateCarrier = "api/Carrier/UpdateCarrierVersion1";
export const deleteCarrier = "api/Carrier/DeleteCarrier";
export const getCarrierList = "api/Carrier/GetCarrierList";
export const viewCarrier = "api/Carrier/viewCarrier";
export const getCarriers = "api/Carrier/GetCarriers";
export const getCarrierAWBList = "api/Carrier/GetCarrierAWBList";
export const getCarrierAWBPacketList = "api/Carrier/GetCarrierAWBPacketList";
export const importCarrierAWB = "api/Carrier/ImportCarrierAWB";
export const importCarrierAWBPacket = "api/Carrier/ImportCarrierAWBPacket";

export const createCarrierStandardRate = "api/CarrierStandardRate/CreateCarrierStandardRateVersion1";
export const createCarrierStandardRateChart = "api/CarrierStandardRate/CreateCarrierStandardRateChart";
export const updateCarrierStandardRate = "api/CarrierStandardRate/UpdateCarrierStandardRate";
export const deleteCarrierStandardRate = "api/CarrierStandardRate/DeleteCarrierStandardRate";
export const getCarrierStandardRateList = "api/CarrierStandardRate/GetCarrierStandardRates";
export const viewCarrierStandardRate = "api/CarrierStandardRate/ViewCarrierStandardRateVersion1";
export const getCarrierStandardRates = "api/CarrierStandardRate/GetCarrierStandardRates";
export const viewCarrierStandardRateChartDetail = "api/CarrierStandardRate/ViewCarrierStandardRateChartDetail";
export const getCarrierStandardRateListV1 = "api/CarrierStandardRate/GetCarrierStandardRateList";

export const updateCarrierRateChart =
  "api/CarrierRateChart/UpdateCarrierRateChart";
export const getCarrierRateCharts = "api/CarrierRateChart/GetCarrierRateCharts";
export const viewCarrierRateChart = "api/CarrierRateChart/ViewCarrierRateChart";
export const viewCarrierRateChartDetail =
  "api/CarrierRateChart/ViewCarrierRateChartDetail";

export const getPostalCodeDetail = "api/PostalCode/ViewPostalCode";
export const validatePostalCodes = "api/PostalCode/ValidatePostalCodes";
export const getViewPostalCodeConfigration = "api/PostalCode/ViewPostalCodeConfigration";

export const validatePostalCodesWithCarrier = "api/PostalCode/ValidatePostalCodesWithCarrier";

export const exportPostalCode = "api/PostalCode/ExportPostalCode";

export const GetConsignorGroupList = "api/ConsignorGroup/GetConsignorGroupList";
export const CreateConsignorGroup = "api/ConsignorGroup/CreateConsignorGroup";
export const ViewConsignorGroup = "api/ConsignorGroup/ViewConsignorGroup";
export const UpdateConsignorGroup = "api/ConsignorGroup/UpdateConsignorGroup";
export const DeleteConsignorGroup = "api/ConsignorGroup/DeleteConsignorGroup";
export const GetConsignorGroups = "api/ConsignorGroup/GetConsignorGroups";

export const GetConsignorZohoSetupList = "api/ConsignorZohoSetup/GetConsignorZohoSetupList";
export const CreateConsignorZohoSetup = "api/ConsignorZohoSetup/CreateConsignorZohoSetup";
export const ViewConsignorZohoSetup = "api/ConsignorZohoSetup/ViewConsignorZohoSetup";
export const UpdateConsignorZohoSetup = "api/ConsignorZohoSetup/UpdateConsignorZohoSetup";
export const DeleteConsignorZohoSetup = "api/ConsignorZohoSetup/DeleteConsignorZohoSetup";
export const getPostalCodesList = "api/PostalCode/GetPostalCodesList";
export const importPostalCode = "api/PostalCode/ImportPostalCode";

export const GetConsignorPickupZoneSetupList = "api/ConsignorPickupZoneSetup/GetConsignorPickUpZoneSetupList";
export const CreateConsignorPickupZoneSetup = "api/ConsignorPickupZoneSetup/CreateConsignorPickUpZoneSetup";
export const ViewConsignorPickupZoneSetup = "api/ConsignorPickupZoneSetup/ViewConsignorPickUpZoneSetup";
export const UpdateConsignorPickupZoneSetup = "api/ConsignorPickupZoneSetup/UpdateConsignorPickUpZoneSetup";
export const DeleteConsignorPickupZoneSetup = "api/ConsignorPickupZoneSetup/DeleteConsignorPickUpZoneSetup";


export const GetConsignorDestinationZoneSetupList = "api/ConsignorDestinationZoneSetup/GetConsignorDestinationZoneSetupList";
export const CreateConsignorDestinationZoneSetup = "api/ConsignorDestinationZoneSetup/CreateConsignorDestinationZoneSetup";
export const ViewConsignorDestinationZoneSetup = "api/ConsignorDestinationZoneSetup/ViewConsignorDestinationZoneSetup";
export const UpdateConsignorDestinationZoneSetup = "api/ConsignorDestinationZoneSetup/UpdateConsignorDestinationZoneSetup";
export const DeleteConsignorDestinationZoneSetup = "api/ConsignorDestinationZoneSetup/DeleteConsignorDestinationZoneSetup";

export const GetCarrierPickupZoneSetupList = "api/CarrierPickupZoneSetup/GetCarrierPickUpZoneSetupList";
export const GetCarrierPickUpZoneSetupListCarrierWise = "api/CarrierPickupZoneSetup/GetCarrierPickUpZoneSetupListCarrierWise";
export const CreateCarrierPickupZoneSetup = "api/CarrierPickupZoneSetup/CreateCarrierPickUpZoneSetup";
export const ViewCarrierPickupZoneSetup = "api/CarrierPickupZoneSetup/ViewCarrierPickUpZoneSetup";
export const UpdateCarrierPickupZoneSetup = "api/CarrierPickupZoneSetup/UpdateCarrierPickUpZoneSetup";
export const DeleteCarrierPickupZoneSetup = "api/CarrierPickupZoneSetup/DeleteCarrierPickUpZoneSetup";

export const CreateConsignorNewRateChart = "api/ConsignorNew/CreateConsignorNewRateChart";
export const ViewConsignorNewRateChartDetail = "api/ConsignorNew/ViewConsignorNewRateChartDetail";
//export const UpdateConsignorNewVersion1 = "api/ConsignorNew/UpdateConsignorNewVersion1";

export const ViewCarrierNewRateChart = "api/CarrierNewRateChart/ViewCarrierNewRateChart";
export const ViewCarrierNewRateChartDetail = "api/CarrierNewRateChart/ViewCarrierNewRateChartDetail";
export const GetCarrierNewRateCharts = "api/CarrierNewRateChart/GetCarrierNewRateCharts";
export const UpdateCarrierNewRateChart = "api/CarrierNewRateChart/UpdateCarrierNewRateChart"

export const ViewCarrierNewRetailRateChart = "api/CarrierNewRetailRateChart/ViewCarrierNewRetailRateChart";
export const ViewCarrierNewRetailRateChartDetail = "api/CarrierNewRetailRateChart/ViewCarrierNewRetailRateChartDetail";
export const GetCarrierNewRetailRateCharts = "api/CarrierNewRetailRateChart/GetCarrierNewRetailRateCharts";
export const UpdateCarrierNewRetailRateChart = "api/CarrierNewRetailRateChart/UpdateCarrierNewRetailRateChart"
export const viewCarrierRateChartPinCodeTAT = "api/Carrier/ViewCarrierRateChartPinCodeTAT";
export const viewCarrierRateChartPinCodeTATZoneWise = "api/Carrier/ViewCarrierRateChartPinCodeTATZoneWise";
export const updateCarrierRateChartPinCodeTATs = "api/Carrier/UpdateCarrierRateChartPinCodeTATs";
export const GetCarrierConsignorSetupList = "api/CarrierPickupZoneSetup/GetCarrierConsignorSetupList"

export const viewConsignorRateChartPinCodeTAT = "api/ConsignorNew/ViewConsignorRateChartPinCodeTAT";
export const updateConsignorRateChartPinCodeTATs = "api/ConsignorNew/UpdateConsignorRateChartPinCodeTATs";

export const createConsignorPickupAddress = "api/ConsignorNew/CreateConsignorPickupAddress";
export const createConsignorPickupAddressTypeWise = "api/ConsignorV1/CreateConsignorPickupAddress";

export const createCarrierRule = "api/CarrierRule/CreateCarrierRule";
export const updateCarrierRule = "api/CarrierRule/UpdateCarrierRule";
export const deleteCarrierRule = "api/CarrierRule/DeleteCarrierRule";
export const getCarrierRuleList = "api/CarrierRule/GetCarrierRuleList";
export const viewCarrierRule = "api/CarrierRule/ViewCarrierRule";
export const getCarrierRules = "api/CarrierRule/GetCarrierRules";



export const tmsMethod = {
  consignee: {
    GetConsignees: "api/Consignee/GetConsignees",
  },

  booking: {
    create: "api/BookShipment/CreateBookShipment",
    bulkUpdatePackets: "api/BookShipment/BulkUpdatePackets",
    list: "api/BookShipment/GetBookShipmentList",
    confirmList: "api/BookShipment/GetConfirmedBookShipmentList",
    cancelList: "api/BookShipment/CancelConfirmBookShipment",
    cancelPrepaid: "api/BookShipment/CancelConfirmBookShipmentWithPrepaid",
    view: "api/BookShipment/ViewBookShipment",
    viewmanage: "api/BookShipment/ViewManageBookShipment",
    viewconfirm: "api/BookShipment/ViewConfirmBookShipment",
    update: "api/BookShipment/UpdateBookShipment",
    delete: "api/BookShipment/DeleteBookShipment",
    tracking: "api/BookShipment/GetBookShipmentStatus",
    carrierInvoiceValidation: "api/BookShipment/CarrierInvoiceValidation",
    carrierInvoiceCreate: "api/CarrierInvoice/AddInvoices",
    getFilteredInvoices: "api/CarrierInvoice/GetFilteredInvoices",
    exportCarrierInvoiceList: "api/CarrierInvoice/ExportCarrierInvoiceList",
    status: "api/BookShipment/GetStatusList",
    updateBookShipmentAWBCarrierWeightDetail: "api/BookShipment/UpdateBookShipmentAWBCarrierWeightDetail",
    validateBookShipmentCarrierWeightImport: "api/BookShipment/ValidateBookShipmentCarrierWeightImport",  
    //confirm: "api/BookShipment/UpdateBookShipmentStatus",
    confirm: "api/BookShipment/UpdateBookShipmentStatusWithLocking",
    manageList: "api/BookShipment/GetManageBookShipmentTracking",
    costAnalysisList: "api/BookShipment/GetCostAnalysis",
    exportcostAnalysisList: "api/BookShipment/ExportCostAnalysis",
    exportManageList: "api/BookShipment/ExportManageBookShipmentList",
    exportBookingList: "api/BookShipment/ExportGetBookShipmentList",
    exportCosnfirmedBookingList: "api/BookShipment/ExportConfirmedBookShipmentList",
    trackingList: "api/BookShipment/GetTrackingBookShipmentList",
    podList: "api/BookShipment/PodList",

    exportTrackingList: "api/BookShipment/ExportTrackingBookShipmentList",
    updateAWB: "api/BookShipment/UpdateBookShipmentAWBDetail",

    updateEwayNumber: "api/BookShipment/UpdateBookShipmentEWayNumber",
    validateBookShipmentEwayNumber: "api/BookShipment/ValidateBookShipmentEwayNumber",


    updateCarrier: "api/BookShipment/UpdateBookShipmentCarrier",
    updateBookShipmentSelfPickUpStatus: "api/BookShipment/UpdateBookShipmentSelfPickUpStatus",
    updateTracking: "api/BookShipment/UpdateBookShipmentTracking",
    generateAwbNo: "api/CarrierIntegration/GetDocketGenerateMerged",
    getDocketGenerateMergedTypeWiseB2C: "api/CarrierIntegration/GetDocketGenerateMergedTypeWiseB2C",

    cancelDocketNo: "api/CarrierIntegration/CancelDocket",
    downloadDocuments: "api/BookShipment/DownloadDocuments",
    validateBookShipmentAWBDetails:
      "api/BookShipment/ValidateBookShipmentAWBDetails",
    validateBookShipmentEwayNumber:
      "api/BookShipment/ValidateBookShipmentEwayNumber",
    ValidateBookShipmenttrackingdetails:
      "api/BookShipment/ValidateBookShipmenttrackingdetails",
    ValidateBookShipment:
      "api/BookShipment/ValidateBookShipment",
    componentWiseCost:
      "api/BookShipment/ComponentWiseCost",
    getZohoBranches: "api/ZohoIntegration/GetZohoBranches",
    getZohoCustomers: "api/ZohoIntegration/GetZohoCustomers",
    getZohoLedger: "api/ZohoIntegration/GetZohoLedger",
    getZohoBookings: "api/ZohoIntegration/GetZohoBookings",
    getZohoFreightDetail: "api/ZohoIntegration/GetZohoInvoiceFreightDetail",
    getZohoPrintInvoice: "api/ZohoIntegration/GetZohoPrintInvoice",
    getZohoCustomerBalance: "api/ZohoIntegration/GetZohoCustomerBalance",
    getConsignorTrackingPageDetail:"api/BookShipment/GetConsignorTrackingPageDetail"    ,
    trackBookingV2:"api/BookShipment/TrackBookingV2"    ,
    performanceDashboardNew: "api/BookShipment/GetTmsPerformanceDashboardNew",
  },
  zoho: {
    generatePayment: "api/ZohoIntegration/GenerateZohoPaymentLink",
    generatePaymentWallet: "api/ZohoIntegration/GenerateWalletPaymentLink",
    generatePaymentiFrame: "api/ZohoIntegration/GenerateWalletPaymentLinkIFrame",
    generatePaymentResponse: "api/ZohoIntegration/GenerateWalletPaymentLinkIFrameResponse"
  },
  ecomorder: {
    create: "api/OrderShipment/CreateOrderShipment",
    bulkUpdatePackets: "api/BookShipment/BulkUpdatePackets",
    list: "api/OrderShipment/GetOrderShipmentList",
    readytoshiplist: "api/OrderShipment/GetReadyToShipOrderShipmentList",
    reverseOrderShipmentList: "api/OrderShipment/GetReverseOrderShipmentList",
    exportGetReadyToShipOrderList: "api/OrderShipment/ExportGetReadyToShipOrderList",
    exportGetRTOOrderList: "api/OrderShipment/ExportGetRTOOrderList",
    cancelOrderShipmentList: "api/OrderShipment/GetCancelOrderShipmentList",
    exportGetCancelOrderList: "api/OrderShipment/ExportGetCancelOrderList",
    getShippedOrderShipmentList: "api/OrderShipment/GetShippedOrderShipmentList",
    exportGetShippedOrderList: "api/OrderShipment/ExportGetShippedOrderList",
    getDeliveredOrderShipmentList: "api/OrderShipment/GetDeliveredOrderShipmentList",
    exportGetDeliveredOrderList: "api/OrderShipment/ExportGetDeliveredOrderList",
    tracking: "api/OrderShipment/GetOrderShipmentStatus",
    downloadDocuments: "api/AWBDocumentPrint/GetB2CAWBShippingDocuments",
    rtolist: "api/OrderShipment/GetRTOOrderShipmentList",
    cancelOrder: "api/OrderShipment/CancelConfirmBookShipment",
    trackBookingV2:"api/OrderShipment/TrackBookingV2"    ,



    confirmList: "api/BookShipment/GetConfirmedBookShipmentList",
    cancelList: "api/BookShipment/CancelConfirmBookShipment",
    view: "api/OrderShipment/ViewOrderShipment",
    viewmanage: "api/BookShipment/ViewManageBookShipment",
    viewconfirm: "api/BookShipment/ViewConfirmBookShipment",
    update: "api/OrderShipment/UpdateOrderShipment",
    delete: "api/OrderShipment/DeleteOrderShipment",
    updateOrderCarrier: "api/OrderShipment/UpdateBookShipmentCarrier",
    //tracking: "api/BookShipment/GetBookShipmentStatus",
    status: "api/BookShipment/GetStatusList",
    confirm: "api/BookShipment/UpdateBookShipmentStatus",
    confirmPrepaid: "api/BookShipment/UpdateBookShipmentStatusWithPrepaid",
    manageList: "api/BookShipment/GetManageBookShipmentTracking",
    costAnalysisList: "api/BookShipment/GetCostAnalysis",
    exportcostAnalysisList: "api/BookShipment/ExportCostAnalysis",
    exportManageList: "api/BookShipment/ExportManageBookShipmentList",
    getZohoLedger: "api/ZohoIntegration/GetZohoLedger",
    getZohoBookings: "api/ZohoIntegration/GetZohoBookings",
    getZohoFreightDetail: "api/ZohoIntegration/GetZohoInvoiceFreightDetail",
    getZohoPrintInvoice: "api/ZohoIntegration/GetZohoPrintInvoice",
    getZohoCustomerBalance: "api/ZohoIntegration/GetZohoCustomerBalance",

    getZohoBranches: "api/ZohoIntegration/GetZohoBranches",
    getZohoCustomers: "api/ZohoIntegration/GetZohoCustomers",
    trackingList: "api/BookShipment/GetTrackingBookShipmentList",
    exportBookingList: "api/BookShipment/ExportGetBookShipmentList",
    exportCosnfirmedBookingList: "api/BookShipment/ExportConfirmedBookShipmentList",
    podList: "api/BookShipment/PodList",

    exportTrackingList: "api/OrderShipment/ExportTrackingBookShipmentList",
    updateAWB: "api/OrderShipment/UpdateBookShipmentAWBDetail",
    updateCarrier: "api/OrderShipment/UpdateBookShipmentCarrier",
    updateBookShipmentSelfPickUpStatus: "api/OrderShipment/UpdateBookShipmentSelfPickUpStatus",

    updateTracking: "api/OrderShipment/UpdateBookShipmentTracking",
    generateAwbNo: "api/CarrierIntegration/GetDocketGenerateMerged",
    cancelDocketNo: "api/CarrierIntegration/CancelDocket",
    //downloadDocuments: "api/OrderShipment/DownloadDocuments",
    updateEwayNumber: "api/OrderShipment/UpdateBookShipmentEWayNumber",
    validateBookShipmentEwayNumber: "api/OrderShipment/ValidateBookShipmentEwayNumber",


    validateBookShipmentAWBDetails:
      "api/OrderShipment/ValidateBookShipmentAWBDetails",
    ValidateBookShipmenttrackingdetails:
      "api/OrderShipment/ValidateBookShipmenttrackingdetails",
    ValidateBookShipment:
      "api/OrderShipment/ValidateBookShipment",
    componentWiseCost:
      "api/OrderShipment/ComponentWiseCost",

  },

  pickup: {

    pendingpickuplist: "api/PickupController/PendingPickupList",
    bookShipmentList: "api/PickupController/BookShipmentList",

  },
  tmsWidget: "api/BookShipment/GetTMSWidget",
  exportWidget: "api/BookShipment/ExportTMSWidget",
  trackShipment: "api/BookShipment/TrackShipment",
  trackShipment: "api/BookShipment/TrackShipment",
  performanceDashboard: "api/BookShipment/GetTmsPerformanceDashboard",
  performanceDashboardNew: "api/BookShipment/GetTmsPerformanceDashboardNew",
  performanceDashboardWeightSummary: "api/BookShipment/GetTmsCarrierPerformanceDashboardWeightSummary",
  performanceDashboardStateSummary: "api/BookShipment/GetTmsCarrierPerformanceDashboardStateSummary",
  carrierPerformanceDashboard: "api/BookShipment/GetTmsCarrierPerformanceDashboard",
  carrierPerformanceDashboardNew: "api/BookShipment/GetTmsCarrierPerformanceDashboardNew",
  exportCarrierPerformanceDashboard: "api/BookShipment/ExportTmsCarrierPerformanceDashboard",
  exportPerformanceDashboard: "api/BookShipment/ExportTmsPerformanceDashboard",
  getZohoLedger: "api/ZohoIntegration/GetZohoLedger",
  getZohoBookings: "api/ZohoIntegration/GetZohoBookings",
  getZohoFreightDetail: "api/ZohoIntegration/GetZohoInvoiceFreightDetail",
  getZohoPrintInvoice: "api/ZohoIntegration/GetZohoPrintInvoice",
  getZohoBranches: "api/ZohoIntegration/GetZohoBranches",
  getZohoCustomers: "api/ZohoIntegration/GetZohoCustomers",


  consignorPincodeanalyser: "api/CalculateShipmentCost/CheckServiceAbility",
  consignorPincodeanalyserWithODA: "api/CalculateShipmentCost/CheckServiceAbilityWithODA",
  carrierCalculator: "api/CalculateShipmentCost/CarrierCalculator",


  AWBPrint: {
    getAWBDocketNotePrint: "api/AWBDocumentPrint/GetAWBDocketNotePrint",
    getAWBShippingLabelPrint: "api/AWBDocumentPrint/GetAWBShippingLabelPrint",
    getAWBShippingLabelPrintMultiple: "api/AWBDocumentPrint/GetAWBShippingLabelPrintWithMultiFiles",
    getB2CAWBShippingLabelPrint: "api/AWBDocumentPrint/GetB2CAWBShippingLabelPrint",

  },

  dimensiongroup: {
    createtmsdimensiongroup: "api/TMSDimensionGroup/CreateTMSDimensionGroup",
    gettmsdimensiongroups: "api/TMSDimensionGroup/GetTMSDimensionGroups",
  },
};
export const blolstorageMethod = {
  upload: "api/BlobStorage/uploadfile",
  delete: "api/BlobStorage/deletefile",
  uploadpod: "api/BookShipment/UploadPod",
};

export const inwardMethod = {
  agrn: {
    createAGRN: "api/AGRN/CreateAGRN",
    updateAGRN: "api/AGRN/UpdateAGRN",
    deleteAGRN: "api/AGRN/DeleteAGRN",
    getAGRNs: "api/AGRN/GetAGRNs",
    getAGRNList: "api/AGRN/GetAGRNList",
    viewAGRN: "api/AGRN/viewAGRN",
    getPendingAGRNs: "api/AGRN/GetPendingAGRNs",
    getAGRNPendingDetail: "api/AGRN/GetAGRNPendingDetail",
  },
  grn: {
    create: "api/GRN/CreateGRN",
    update: "api/GRN/UpdateGRN",
    delete: "api/GRN/DeleteGRN",
    getGRNs: "api/GRN/GetGRNs",
    getGRNList: "api/GRN/GetGRNList",

    view: "api/GRN/viewGRN",
  },
  serialNumber: {
    generate: "api/SerialNumber/GenerateSerialNumber",
    getSerialNumberList: "api/SerialNumber/GetSerialNumberList",
  },
};
